import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Top1: FC<IconSvgProps> = ({ clss, width = 25, height = 25, hideText }) => {
    return (
        <svg className={clss} width={width} height={height} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12.1327" cy="12.1327" r="11.6327" fill="url(#paint0_linear_top1)" stroke="url(#paint1_linear_top1)" />
            {!hideText && <path d="M11.6542 17.2035V9.18149H10.0302L10.8142 7.86549H13.0822V17.2035H11.6542Z" fill="#000D44" fillOpacity="0.1" />}
            <defs>
                <linearGradient id="paint0_linear_top1" x1="12.1327" y1="3.65668" x2="33.2572" y2="16.506" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFE59A" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint1_linear_top1" x1="24.2336" y1="28.5898" x2="1" y2="-0.694114" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFE59A" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default Top1;
